import React from "react";
import { Outlet, useNavigate, Navigate } from "react-router-dom";
import Dashboard from "./Dashboard";
import Menu from "../assets/icon/menu.svg";
import { UseAllState } from "../Context";
import "../index.css";

const menuItems = [
  "/Mainpage/EditProfile",
  "/Mainpage/AddTeacher",
  "/Mainpage/AddStudent",
  "/Mainpage/AddCourse",
  "/Mainpage/CoursesInf",
  "/Mainpage/StudentsInf",
  "/Mainpage/TeachersInf",
  "/Mainpage/Attendance",
  "/Mainpage/FinancialBalance",
  "/Mainpage/ListOfDebtors",
];
const Mainpage = () => {
  const { shownav, handleShownav } = UseAllState();
  const navigate = useNavigate();
  return (
    <>
      {localStorage.getItem("token") !== null ? (
        <div className="w-full font-iranSansNormal h-screen flex relative overflow-hidden">
          <div
            className={`
              bg-white rounded-l-[30px] h-full 
              xxl:w-[16%] xl:w-[20%] lg:w-[26%] 
              ${
                shownav
                  ? "absolute z-20 xs:w-full sm:w-[50%] md:w-[40%]"
                  : "hidden"
              }
              xxl:relative xl:relative lg:relative xxl:block xl:block lg:block
            `}
          >
            <Dashboard
              myclick={(pageIndex) => {
                navigate(menuItems[pageIndex]);
              }}
            />
          </div>
          <div
            className={`flex-1 bg-[#ebebeb]   h-full flex flex-col relative ${
              shownav
                ? "opacity-30 xs:opacity-30 sm:opacity-30 md:opacity-30"
                : "opacity-100"
            }`}
          >
            <div
              onClick={handleShownav}
              className="cursor-pointer xxl:hidden xl:hidden lg:hidden w-full"
            >
              <img
                className="mr-[20px] w-[36px] h-[36px] mt-[12px]"
                src={Menu}
                alt="Menu"
              />
            </div>
            <div className="flex-1 px-3 overflow-y-auto scrollbar-hide">
              <Outlet />
            </div>
          </div>
        </div>
      ) : (
        <Navigate to="/" />
      )}
    </>
  );
};

export default Mainpage;
